import React, { useMemo, useState } from "react";
import {
  METER_BOTH,
  METER_HOUR,
  METER_ODOMETER,
  normalizeMeterType,
} from "./fieldAppMeterLabels";

function todayIso() {
  const now = new Date();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  return `${now.getFullYear()}-${month}-${day}`;
}

function meterNeeds(meterType) {
  const normalized = normalizeMeterType(meterType);
  return {
    needsHours:
      normalized === METER_HOUR ||
      normalized === METER_BOTH ||
      normalized === "h",
    needsKm:
      normalized === METER_ODOMETER ||
      normalized === METER_BOTH ||
      normalized === "km",
  };
}

export default function FieldAppCompleteMaintenanceModal({
  row,
  t,
  saving,
  onClose,
  onSubmit,
}) {
  const machineName =
    (row && (row.equipment_name || row.machineName || row.machineIdent)) || "—";
  const taskName =
    (row && (row.name || row.maintenanceType || row.maintenanceTitle)) || "—";
  const currentHours =
    row &&
    (row.currentHourMeterDisplay != null
      ? row.currentHourMeterDisplay
      : row.currentHourMeter);
  const needs = useMemo(() => meterNeeds(row && row.meterType), [row]);
  const [completedDate, setCompletedDate] = useState(todayIso());
  const [hourMeter, setHourMeter] = useState(
    currentHours != null ? String(currentHours) : ""
  );
  const [odometer, setOdometer] = useState("");
  const [error, setError] = useState("");

  if (!row) return null;

  const handleSubmit = (event) => {
    event.preventDefault();
    const hours = Number(String(hourMeter).replace(",", "."));
    const km = Number(String(odometer).replace(",", "."));
    if (!completedDate) {
      setError(t("Informe a data da conclusão."));
      return;
    }
    if (needs.needsHours && (!hourMeter || !Number.isFinite(hours) || hours < 0)) {
      setError(t("Informe o horímetro atual da máquina."));
      return;
    }
    if (needs.needsKm && (!odometer || !Number.isFinite(km) || km < 0)) {
      setError(t("Informe a quilometragem atual da máquina."));
      return;
    }
    setError("");
    onSubmit({
      completedDate,
      hourMeter: needs.needsHours ? hours : undefined,
      odometer: needs.needsKm ? km : undefined,
    });
  };

  return (
    <div className="field-app-modal-backdrop" onClick={onClose}>
      <div
        className="field-app-modal field-app-complete-maintenance-modal"
        onClick={(event) => event.stopPropagation()}
        role="dialog"
        aria-modal="true"
      >
        <div className="field-app-modal-header">
          <h3>{t("Concluir manutenção hoje")}</h3>
          <button
            type="button"
            className="close"
            onClick={onClose}
            aria-label={t("Fechar")}
          >
            ×
          </button>
        </div>
        <form className="field-app-complete-maintenance-form" onSubmit={handleSubmit}>
          <p>
            {t("Máquina")}: <strong>{machineName}</strong>
            <br />
            {t("Tarefa")}: <strong>{taskName}</strong>
          </p>
          <label htmlFor="complete-maintenance-date">
            {t("Data da conclusão")}
          </label>
          <input
            id="complete-maintenance-date"
            type="date"
            className="form-control"
            value={completedDate}
            onChange={(event) => setCompletedDate(event.target.value)}
            required
          />
          {needs.needsHours ? (
            <>
              <label htmlFor="complete-maintenance-hours">
                {t("Horímetro atual (h)")} *
              </label>
              <input
                id="complete-maintenance-hours"
                type="number"
                min="0"
                step="0.1"
                className="form-control"
                value={hourMeter}
                onChange={(event) => setHourMeter(event.target.value)}
                required
              />
            </>
          ) : null}
          {needs.needsKm ? (
            <>
              <label htmlFor="complete-maintenance-km">
                {t("Quilometragem atual (km)")} *
              </label>
              <input
                id="complete-maintenance-km"
                type="number"
                min="0"
                step="0.1"
                className="form-control"
                value={odometer}
                onChange={(event) => setOdometer(event.target.value)}
                required
              />
            </>
          ) : null}
          {error ? <p className="text-danger">{error}</p> : null}
          <div className="field-app-complete-maintenance-actions">
            <button
              type="button"
              className="btn btn-default"
              onClick={onClose}
              disabled={saving}
            >
              {t("Cancelar")}
            </button>
            <button type="submit" className="btn btn-primary" disabled={saving}>
              {saving ? t("Salvando...") : t("Confirmar conclusão")}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
